const translations = {
  title: 'Templates',
  titleDetails: 'Details',
  titleEdit: 'Edit Templates',
  insertedAt: 'Inserted At: ',
  updatedAt: 'Update At: ',
  entity: 'Entity',
  description: 'Description',
  addNew: 'Add new Template',
  docsGenerate: 'Generated Docs',
  'input.addDocument': 'Add Document',
  'input.isDisabled': 'Disable Template',
  'input.name': 'Fill docs name',
  modalTitle: 'Creating template',
  modalTitle_edit: 'Editing template',
  listTitle: 'Document templates',
  addNewButton: 'Add New',
  exclusiveForChecklist: 'Exclusive for checklist (optional)',
  exclusiveForPlaceType: 'Exclusive for destination type (optional)',
  type: 'Type'
}

export default translations
